import React from 'react';
import { FmButton, type FmButtonVariant } from './FmButton';
import { FmInline } from './FmComposition';
import { useFmMapViewport } from './FmMapViewportContext';
import './FmMapViewportControls.css';

export interface FmMapViewportControlsProps {
  fitLabel: string;
  zoomInLabel?: string;
  zoomOutLabel?: string;
  fitOnly?: boolean;
  /** Use `default` on an over-map plate so the plate, not the button, owns the border. */
  variant?: FmButtonVariant;
}

export const FmMapViewportControls: React.FC<FmMapViewportControlsProps> = ({
  fitLabel,
  zoomInLabel,
  zoomOutLabel,
  fitOnly = false,
  variant = 'bordered',
}) => {
  const { controller } = useFmMapViewport();
  return (
    <FmInline
      as="fieldset"
      gap="xs"
      aria-label={fitLabel}
      className="fm-map-viewport-controls"
    >
      <FmButton
        size="sm"
        variant={variant}
        disabled={!controller}
        onClick={controller?.fit}
        aria-label={fitLabel}
      >
        {fitLabel}
      </FmButton>
      {!fitOnly ? (
        <>
          <FmButton
            size="sm"
            variant={variant}
            disabled={!controller}
            onClick={controller?.zoomIn}
            aria-label={zoomInLabel}
          >
            +
          </FmButton>
          <FmButton
            size="sm"
            variant={variant}
            disabled={!controller}
            onClick={controller?.zoomOut}
            aria-label={zoomOutLabel}
          >
            −
          </FmButton>
        </>
      ) : null}
    </FmInline>
  );
};
